import { motion } from "framer-motion";

const UNDERSTOOD_IMG = "/images/sawyer-3.webp";

export const Understood = () => (
  <section data-testid="understood-section" className="bg-white border-y border-line">
    <div className="max-w-6xl mx-auto px-6 py-24 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        className="lg:col-span-5 order-2 lg:order-1"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <img
          data-testid="understood-image"
          src={UNDERSTOOD_IMG}
          alt="Sawyer filming content on her phone in the studio"
          className="rounded-2xl object-cover aspect-square w-full"
        />
      </motion.div>
      <motion.div
        className="lg:col-span-7 order-1 lg:order-2"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <p className="font-accent text-2xl text-clay mb-3">okay, real talk</p>
        <h2 data-testid="understood-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-ink">
          you know you want to create… but maybe you just feel stuck.
        </h2>
        <div className="mt-6 space-y-4 text-base sm:text-lg text-stone-text leading-relaxed max-w-xl">
          <p>
            maybe you've felt it for a while — like there's something in you that you want to share through fitness + wellness.
          </p>
          <p>
            but when it actually comes time to create, you don't know what to post. you're not inspired. you overthink it. or you post consistently and still feel like nothing is really moving.
          </p>
          <p>
            and with SO much content advice online, it can honestly just make it harder to know what actually matters.
          </p>
          <p className="font-semibold text-ink">
            so i want to let you in on what i've learned building my own platform + what i wish i knew when i started.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
